import React, { useEffect } from "react";
import { CheckoutDetailHeader, CheckoutDetailTabs } from "../components";
import { useCore } from "../hooks";
import { Schema } from "../utils";

export const CheckoutDetail: React.FC = () => {
  const { core, checkouts, setCheckouts } = useCore()

  useEffect(() => {
    const allowedIds = checkouts.map(c => c.id)
    core.services.checkout.getList({ filters: {} }, Schema.checkout.detail)
      .then(r => setCheckouts((r.items || []).filter(c => c.enabled && allowedIds.includes(c.id))))
  }, [])

  return (
    <div className="w-full">
      <CheckoutDetailHeader />
      <div>
        <CheckoutDetailTabs />
      </div>
    </div>
  )
}
